export const getPoiTypeLayerDataUrl =
  "/api/v1/point/type/:poiTypeLayer/heatmap";
